"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonEntityIdDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const common_entity_dto_1 = require("./common-entity.dto");
class CommonEntityIdDto extends swagger_1.PickType(common_entity_dto_1.CommonEntityDto, ['id']) {
}
exports.CommonEntityIdDto = CommonEntityIdDto;
//# sourceMappingURL=common-entity-id.dto.js.map